<template>
	<div>
		<p>На этой странице находится краткое описание изменений в приложении.</p>
		<el-collapse v-model="activeNames">
			<!-- <el-collapse-item title="Обновление от 08.09.2019" name="2">
			    <ul>
			    	<li></li>
		    	</ul>
			</el-collapse-item> -->
			<el-collapse-item title="Обновление от 25.08.2019" name="1">
			    <ul>
			    	<li>Добавил информационные всплывашки в правом верхнем углу для некоторых событий, например для добавления, обновления, удаления предмета из коллекции.</li>
			    	<li>Поправил фильтр выводимых предметов на странице коллекции только по действительно существующим модификациям с наличием предметов.</li>
			    	<li>Добавил вкладку "Обновления", содержащую краткое описание изменений в приложении.</li>
			    	<li>Добавил спойлер в коллекции предметов слева в ряду. По его нажатии открывается установленный рецепт предмета в случае, если цена предмета расчитывается через рецепт.</li>
			    	<li>Добавил рецепты для модификаций:
			    		<ul>
			    			<li>Applied Energistics 2 Stuff;</li>
			    			<li>Advanced Solar Panels 3;</li>
			    			<li>Advanced Machines.</li>
			    		</ul>
			    	</li>
		    	</ul>
			</el-collapse-item>
		</el-collapse>
	</div>	
</template>

<script>
export default {
  	data() {
	    return {
	    	activeNames: [],
	    };
  	},
};
</script>
